// src/layouts/PublicLayout.tsx
// Shared layout for landing + auth pages — renders the animated metaball
// background once so it persists across client-side navigation. The background
// is lazy so the legacy engine stays out of the entry chunk.
// Ported from Next.js app/(public)/layout.tsx.

import { lazy, Suspense } from 'react'
import { Outlet } from 'react-router'

const AnimatedBackground = lazy(() =>
  import('@/components/landing/AnimatedBackground').then((m) => ({
    default: m.AnimatedBackground,
  })),
)

export default function PublicLayout() {
  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Animated background — shared across landing and auth pages */}
      <div
        className="absolute inset-0"
        style={{ isolation: 'isolate', zIndex: 0 }}
      >
        <Suspense fallback={null}>
          <AnimatedBackground intensity="subtle" />
        </Suspense>
      </div>

      {/* Page content */}
      <div className="relative z-10">
        <Outlet />
      </div>
    </div>
  )
}
